






















import { CashFlowTransactionType } from "@/models/enums/CashFlowTransactionType.enum";
import { Component, Prop, Vue } from "vue-property-decorator";

interface TransactionTypeOption {
  value: CashFlowTransactionType;
  label: string;
}

@Component
export default class CashFlowTransactionTypeSelect extends Vue {
  @Prop({ required: true, type: Array })
  value!: CashFlowTransactionType[];

  @Prop({ default: "" })
  placeholder!: string;

  get transactionTypeOptions(): TransactionTypeOption[] {
    return Object.values(CashFlowTransactionType).map(type => ({
      value: type,
      label: this.$t(this.getI18nKey(type)) as string,
    }));
  }

  getI18nKey(type: CashFlowTransactionType): string {
    const keyMap: Record<CashFlowTransactionType, string> = {
      [CashFlowTransactionType.AR_RECEIPT]: "lbl_ar_receipt",
      [CashFlowTransactionType.AP_PAYMENT]: "lbl_ap_payment",
      [CashFlowTransactionType.CASH_IN]: "lbl_cash_in",
      [CashFlowTransactionType.CASH_OUT]: "lbl_cash_out",
    };
    return keyMap[type];
  }
}
